import React, { useState, useRef, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import SearchBar from "./serachBar";
import ProductList from "./ProductList";
import "./IlifeModal.scss";
import "./NewModal.css";
import IlifestyleService from "../../../service/ilifestyle/ilifestyle";
import { AlertMessage } from "../common";
import { Select, MenuItem } from "@material-ui/core";
import AppInfoservice from "../../../service/common/Appinfo";

function IlifeModal(props) {
  console.log(props?.state, "props?.state");
  const modalRef = useRef(null);
  const [cardNo, setCardNo] = useState(props.card);
  const [password, setPassword] = useState("");
  const [epoint, setEpoint] = useState("");
  const [category, setCategory] = useState("");
  const [quantity, setQuantity] = useState("");
  const [totalPoints, setTotalPoints] = useState("");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [pointConversionProducts, setPointConversionProducts] = useState([]);
  const [petronCards, setPetronCards] = useState([]);
  const [conversionSelection, setConversionSelection] = useState({
    category: "",
    quantity: 1,
    totalEPoints: 0,
    amount: 0,
    password: "",
    convenienceFee: 0,
    totalPointsToDeduct: 0,
    isPetron: 0,
    petron: "",
    releaseMethod: "",
    selectedAddress: "",
    stockDeductionTo: "",
  });
  const releaseMethod = props.state.releaseMethod ?? [];
  const deliveryMethod = props.state.deliveryMethod ?? [];
  console.log({ deliveryMethod });
  const getAddressByShippingCode = () => {
    const item = deliveryMethod.find(
      (entry) => entry.shipping_code === "pickup"
    );
    return item ? item.address : null;
  };
  const stockDeductionIdByShippingCode = (shippingCode) => {
    const item = deliveryMethod.find(
      (entry) => entry.shipping_code === shippingCode
    );
    return item ? item.stock_deduction_to_id : null;
  };
  const pickupAddress = props.state.pickupAddress ?? "";
  const addressDetails = props.state.addressDetails ?? [];
  console.log(pointConversionProducts, "props lifemodal");

  const changeConversionSelection = (e) => {
    console.log(pointConversionProducts);
    console.log("change conversion selection");
    let currentConvenienceFee = Number(conversionSelection.convenienceFee);
    console.log("change conversion selection", currentConvenienceFee);
    if (e.target.name == "category") {
      console.log("change conversion selection inside category");
      const product = pointConversionProducts.find(
        (item) => item.product_id == e.target.value
      );
      console.log("change conversion selection", product);
      let totalPointsToDeduct = product?.pointRequired
          ? Number(product.pointRequired) + currentConvenienceFee
          : 0,
        quantity = conversionSelection.quantity ?? 1;
      setConversionSelection((prevRequest) => ({
        ...prevRequest,
        [e.target.name]: e.target.value,
        totalEPoints: product?.pointRequired ? product?.pointRequired : 0,
        amount: product?.pointRequired
          ? Number(Number(product.pointRequired) / 8) * Number(quantity)
          : 0,
        totalPointsToDeduct,
        isPetron: product?.petron_card == 1 ? 1 : 0,
      }));
    } else if (e.target.name == "quantity") {
      const product = pointConversionProducts.find(
        (item) => item.product_id == conversionSelection.category
      );
      let pointRequired = product ? Number(product.pointRequired) : 0;
      let totalEPoints = product
        ? Number(product.pointRequired) * Number(e.target.value)
        : 0;
      let totalPointsToDeduct = Number(totalEPoints) + currentConvenienceFee;
      let amount = (pointRequired / 8) * Number(e.target.value);
      setConversionSelection((prevRequest) => ({
        ...prevRequest,
        quantity: e.target.value,
        totalEPoints,
        amount,
        totalPointsToDeduct,
      }));
    } else if (e.target.name == "releaseMethod") {
      const stockDeductionTo = stockDeductionIdByShippingCode(e.target.value);
      setConversionSelection((prevRequest) => ({
        ...prevRequest,
        [e.target.name]: e.target.value,
        stockDeductionTo: stockDeductionTo,
      }));
    } else {
      setConversionSelection((prevRequest) => ({
        ...prevRequest,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const service = new IlifestyleService();
  const handleSamsugStore = async () => {
    const response = await service.SamsungStore();
    console.log(response, "response");
    if (response) {
      console.log("samsung store response", response);
      setLoading(false);
    } else {
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured. Please Try Again Later",
      }));
    }
  };
  const handleCardNoChange = (event) => {
    setCardNo(event.target.value);
  };

  const pointConversionProductPurchase = async () => {
    setLoading(true);
    try {
      let data = {
        category: conversionSelection.category,
        quantity: conversionSelection.quantity,
        password: conversionSelection.password,
        totalPointsToDeduct: conversionSelection.totalPointsToDeduct,
        convenienceFee: conversionSelection.convenienceFee,
        releaseMethod: conversionSelection.releaseMethod,
        selectedAddress: conversionSelection.selectedAddress,
        isPetron: conversionSelection.isPetron,
        petron: conversionSelection.petron,
        stockDeductionTo: conversionSelection.stockDeductionTo,
        description: conversionSelection.description,
      };
      const purchasePointConversion =
        await service.purchaseProductForPointConversion(data);
      setLoading(false);
      if (purchasePointConversion.status === false) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: purchasePointConversion?.error?.description
            ? purchasePointConversion?.error?.description
            : "Some Error Occured",
        }));
      } else {
        setConversionSelection((prevRequest) => ({
          ...prevRequest,
          category: "",
          quantity: 1,
          totalEPoints: 0,
          amount: 0,
          password: "",
        }));
        props.setReload(!props.reload);
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "success",
          message: "I-LifeStyle Point Conversion Completed.",
        }));
      }
    } catch (err) {
      setLoading(false);
      console.log(err);
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: "Some Error Occured",
      }));
    }
  };

  const [notify, setnotify] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [consolidation, setConsolidation] = useState({
    account: "",
    points: 0,
    password: "",
    loading: false,
  });

  const notifyDissmissed = () => {
    setnotify((prev) => ({
      ...prev,
      show: false,
    }));
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };
  const handleEPointChange = (event) => {
    setEpoint(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  const handleConsolidation = (e) => {
    console.log(e.target.name);
    setConsolidation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleTotalPointsChange = (event) => {
    setTotalPoints(event.target.value);
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const handleSubmit = async () => {
    let data = {
      card: cardNo,
      password,
    };
    setLoading(true);
    if (props.item.id == 1) {
      if (cardNo == "" || password == "") {
        setLoading(false);
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: "Card Number and Password is Required.",
        }));
      } else {
        const addPetronCardResponse = await service.petronCardEnrollment(data);
        setLoading(false);
        console.log(addPetronCardResponse, "addPetronCardResponse");
        if (addPetronCardResponse.status === false) {
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "danger",
            message: addPetronCardResponse.error.description,
          }));
        } else {
          setnotify((prev) => ({
            ...prev,
            show: true,
            type: "success",
            message: "Petron card enrollment success.",
          }));
        }
      }
    }
  };

  const CloseIcon = () => (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );

  const handlePointTransfer = async () => {
    setConsolidation((prevState) => ({
      ...prevState,
      loading: true,
    }));

    let data = {
      pswd: consolidation.password,
      amount: consolidation.points,
      to_user_name: consolidation.account,
    };
    const errorMessage =
      consolidation.points <= 0
        ? "Points must be valid"
        : consolidation.account === ""
        ? "Account cannot be empty"
        : consolidation.password === ""
        ? "Password cannot be empty"
        : "";

    if (errorMessage) {
      setnotify((prev) => ({
        ...prev,
        show: true,
        type: "danger",
        message: errorMessage,
      }));
      setConsolidation((prevState) => ({
        ...prevState,
        loading: false,
      }));
      return;
    } else {
      const pointTransferResponse = await service.pointTransfer(data);
      setConsolidation((prevState) => ({
        ...prevState,
        loading: false,
      }));
      console.log(pointTransferResponse, "pointTransferResponse");
      if (pointTransferResponse.status === false) {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: pointTransferResponse.error?.description
            ? pointTransferResponse.error?.description
            : "Some Error Occured...!",
        }));
      } else {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "success",
          message: "Point Transfer Completed Successfully.",
        }));
        props.setReload(!props.reload);
        setConsolidation((prevState) => ({
          ...prevState,
          account: "",
          points: 0,
          password: "",
        }));
      }
    }
  };

  useEffect(() => {
    if (props.item.id === 4) {
      handleLifeStylePurchase();
    } else if (props.item.id === 2) {
      getProductsForConversion();
    }
    const handleOutsideClick = (event) => {
      console.log("Clicked outside");
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        console.log("Closing modal");
        props.onClose();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [props.onClose, props.item.id]);

  const handleLifeStylePurchase = async () => {
    const service = new AppInfoservice();
    service.getStoreUrl("lifestyle").then((res) => {
      if (res.status) {
        window.location.href = res.data.url;
        console.log(res.data.url);
      } else {
        setnotify((prev) => ({
          ...prev,
          show: true,
          type: "danger",
          message: "Some Error Occured. Please Try Again Later",
        }));
      }
    });
  };

  const getProductsForConversion = async () => {
    const service = new IlifestyleService();
    service.productsForConversion().then((res) => {
      console.log(res, "responsoe for product conversion");
      if (res.status) {
        // console.log(res.data)
        setPetronCards(res.data.cardDetails);
        setPointConversionProducts(res.data.products);
        setConversionSelection((prevRequest) => ({
          ...prevRequest,
          convenienceFee: res.data.convenienceFee ?? 0,
          totalPointsToDeduct: res.data.convenienceFee ?? 0,
        }));
      }
    });
  };

  return (
    <div className="modall-wrapper">
      <div className="modall" ref={modalRef}>
        <button className="close-button" onClick={props.onClose}>
          <CloseIcon />
        </button>
        <div className="modall-content">
          {props.item.id === 1 && (
            <div className="modals">
              <div className="bordergreen"></div>
              <div className="headlabel">{props.item.label}</div>
              <div style={{ fontSize: "10px" }}>
                {" "}
                Please enter below details{" "}
              </div>
              <br />
              <br />
              <Form.Group controlId="formCardNo">
                <Form.Label>Enter Petron Card No.</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="xxxx-xxxx-xxxx-xxxx"
                  value={cardNo}
                  onChange={handleCardNoChange}
                />
              </Form.Group>

              <Form.Group controlId="formPassword">
                <Form.Label>Enter Password</Form.Label>
                <Form.Control
                  placeholder="********"
                  type="password"
                  value={password}
                  onChange={handlePasswordChange}
                />
              </Form.Group>
              <br />
              <Button
                style={{
                  fontSize: "10px",
                  borderRadius: "2px",
                  height: "28px",
                  width: "170px",
                }}
                variant="success"
                onClick={handleSubmit}
                disabled={loading}
              >
                <strong>{loading ? "Loading.." : "Activate Card"}</strong>
              </Button>
            </div>
          )}
          {props.item.id === 2 && (
            <div className="modalCommonStyle">
              <div
                className="offcanvas offcanvas-end"
                tabindex="-1"
                id="offcanvasRight"
                aria-labelledby="offcanvasRightLabel"
              >
                <div className="offcanvas-header">
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="offcanvas-body">
                  <div className="borderTopLine"></div>
                  <h5>{props.item.label}</h5>
                  <p style={{ fontWeight: "bold" }}>
                    Please enter below details.
                  </p>
                  <br />
                  <br />

                  <div className="inputClassFiles">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Category</label>
                        </div>
                        <select
                          name="category"
                          id="type"
                          defaultValue=""
                          value={conversionSelection.category}
                          onChange={changeConversionSelection}
                        >
                          <option value="" disabled>
                            Select Category
                          </option>
                          {pointConversionProducts.map((product) => {
                            return (
                              <option
                                key={product.product_id}
                                value={product.product_id}
                              >{`${product.name} (${product.pointRequired} PTS)`}</option>
                            );
                          })}
                        </select>
                      </div>
                      {conversionSelection.isPetron === 1 &&
                        petronCards.length > 0 && (
                          <div className="col-md-12">
                            <div className="labelClass">
                              <label for="">Petron Card</label>
                            </div>
                            <select
                              name="petron"
                              id="type"
                              defaultValue=""
                              value={conversionSelection.petron}
                              onChange={changeConversionSelection}
                            >
                              <option value="" disabled>
                                Select Card
                              </option>
                              {petronCards.map((card) => {
                                return (
                                  <option key={card.id} value={card.card}>
                                    {card.card}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        )}

                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Quantity *</label>
                        </div>
                        <input
                          placeholder="Enter Quantity"
                          type="number"
                          name="quantity"
                          value={conversionSelection.quantity}
                          onChange={changeConversionSelection}
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Amount *</label>
                        </div>
                        <input
                          placeholder="Amount"
                          type="number"
                          name="amount"
                          disabled={true}
                          value={conversionSelection.amount}
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Total ePoints *</label>
                        </div>
                        <input
                          placeholder="Total ePoints"
                          type="number"
                          name="epoints"
                          disabled={true}
                          value={conversionSelection.totalEPoints}
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Convenience Fee</label>
                        </div>
                        <input
                          placeholder="Convenience Fee"
                          type="number"
                          name="convenienceFee"
                          disabled={true}
                          value={conversionSelection.convenienceFee}
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Total ePoints to Deduct*</label>
                        </div>
                        <input
                          placeholder="Total ePoints"
                          type="number"
                          name="totalPointsToDeduct"
                          disabled={true}
                          value={conversionSelection.totalPointsToDeduct}
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Release Method:</label>
                        </div>
                        <select
                          name="releaseMethod"
                          id="type"
                          value={conversionSelection.releaseMethod}
                          onChange={changeConversionSelection}
                          defaultValue=""
                        >
                          <option value="" disabled>
                            Select Release Method
                          </option>
                          {deliveryMethod.map((type) => {
                            return (
                              <option value={type.shipping_code}>
                                {type.description}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      {conversionSelection.releaseMethod === "pickup" && (
                        <div className="col-md-12 m-2">
                          <p style={{ color: "red" }}>
                            {getAddressByShippingCode()}
                          </p>
                        </div>
                      )}
                      {conversionSelection.releaseMethod == "shipout" && (
                        <div className="col-md-12">
                          <div className="labelClass">
                            <label for="">Address:</label>
                          </div>
                          <select
                            name="selectedAddress"
                            id="type"
                            value={conversionSelection.selectedAddress}
                            onChange={changeConversionSelection}
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Select Address{" "}
                            </option>
                            {addressDetails.map((address) => {
                              return (
                                <option value={address.id}>
                                  {address.addressName}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      )}
                      <br />
                      <br />
                      <br />
                      <div className="col-md-12">
                        <div className="labelClass">
                          <label for="">Enter Password</label>
                        </div>
                        <input
                          placeholder="Enter Password"
                          type="password"
                          name="password"
                          value={conversionSelection.password}
                          onChange={changeConversionSelection}
                        />
                      </div>
                    </div>
                    {/* <h3>Review Encashment Details</h3> */}
                    <br />
                    <br />
                  </div>
                  <button
                    type="button"
                    style={{
                      backgroundColor: "#00AF50",
                      padding: "1em",
                      borderRadius: ".2em",
                    }}
                    onClick={pointConversionProductPurchase}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "SUBMIT"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {props.item.id === 3 && (
            <div className="modals">
              <div className="bordergreen"></div>
              <div className="headlabel">{props.item.label}</div>
              <div style={{ fontSize: "10px" }}>
                Please enter the following details:
              </div>
              <div style={{ fontSize: "10px" }}>
                NOTE: Only extension accounts with remaining epoints are shown.
              </div>
              <br />
              <br />
              <div className="table">
                <table>
                  <thead>
                    <tr>
                      <th style={{ border: "0.1px  solid gray" }}>
                        <div className="labelname"> Username</div>
                      </th>
                      <th style={{ border: "0.1px solid  gray" }}>
                        <div className="labelname"> Fullname</div>
                      </th>
                      <th style={{ border: "0.1px solid gray" }}>
                        <div className="labelname"> Accumulated ePoints</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.extensionAccountDetails.map((user) => {
                      return (
                        <tr>
                          <td>
                            <div className="labelname">{user.username}</div>
                          </td>
                          <td>
                            <div className="labelname">{user.fullName}</div>
                          </td>
                          <td>
                            <div className="labelname">
                              {user.Accumulated_ePoints}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <br />
              <div className="id-two">
                <Form.Group controlId="formCategory">
                  <Form.Label for="category">Select Account:</Form.Label>
                  <Form.Control
                    id="account"
                    name="account"
                    type="text"
                    as="select"
                    value={consolidation.account || ""}
                    onChange={handleConsolidation}
                    defaultValue=""
                    displayEmpty
                    // style={{ height: "25px" }}
                    style={{ width: "250px" }}
                  >
                    <option value="" disabled style={{ cursor: "pointer" }}>
                      Select Extension Account
                    </option>
                    {props.extensionAccountDetails.map((user) => {
                      return (
                        <option className="labelname" value={user.username}>
                          {user.username}
                        </option>
                      );
                    })}
                  </Form.Control>
                </Form.Group>
                <br />
                <Form.Group controlId="formPointsToTransfer">
                  <Form.Label>
                    <div className="labelname">
                      Enter I - Lifestyle Points to transfer:
                    </div>
                  </Form.Label>
                  <Form.Control
                    placeholder="Enter Points To Transfer"
                    type="number"
                    value={consolidation.points}
                    name="points"
                    onChange={handleConsolidation}
                    style={{ width: "250px" }}
                  />
                </Form.Group>
                <br />
                <Form.Group controlId="formPassword">
                  <Form.Label>
                    <div className="labelname">
                      Enter Password (Enter Password for selected Extension
                      Account)
                    </div>
                  </Form.Label>
                  <Form.Control
                    placeholder="Enter Password"
                    type="password"
                    name="password"
                    value={consolidation.password}
                    onChange={handleConsolidation}
                    style={{ width: "250px", height: "46px" }}
                  />
                </Form.Group>
                {/* <br /> */}
              </div>
              <Button
                style={{
                  fontSize: "14px",
                  borderRadius: "2px",
                  height: "32px",
                  width: "170px",
                }}
                variant="success"
                onClick={handlePointTransfer}
                disabled={consolidation.loading}
              >
                <strong>{consolidation.loading ? "Loading" : "Submit"}</strong>
              </Button>
            </div>
          )}
          {props.item.id === 4 && (
            <div className="modals">
              <h3> Please Wait You Will Be Redirected </h3>
            </div>
          )}
        </div>
      </div>
      {notify.show && (
        <div>
          <AlertMessage
            message={notify.message}
            dismiss={notifyDissmissed}
            type={notify.type}
            header={notify.header}
            show={notify.show}
          />
        </div>
      )}
    </div>
  );
}

export default IlifeModal;
